import React from "react";
import PulseLoader from "react-spinners/PulseLoader";
import styled from "styled-components";

function Loading({ loading }) {
  return (
    <Div>
      <PulseLoader color="#fff" loading={loading} size={15} />
    </Div>
  );
}

export default Loading;

const Div = styled.div`
  display: flex;
  position: absolute;
  text-align: center;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
